import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import servicesImage from '../../Assets/Images/services.jpg'; // Replace with an actual image if you want

import './Services.css';

const Services = () => {
  return (
    <div className="services-page-main">
      <div className="services-content-box">
        <div className="services-top-row">
          <div className="services-text-left">
            <h1>Our Services</h1>
            <p>
              At Cowdog Tech, we provide expert electronics repair, custom modifications, and unique projects tailored to your needs. Explore the options below to learn more about each service.
            </p>

            <ul className="services-links-list">
              <li>
                <Link to="/services/repair" className="services-link">
                  Game Console & Computer Repair
                </Link>
              </li>
              <li>
                <Link to="/services/modifications" className="services-link">
                  Console & Computer Modifications
                </Link>
              </li>
              <li>
                <Link to="/services/custom" className="services-link">
                  Custom & Unique Projects
                </Link>
              </li>
            </ul>
          </div>

          <div className="services-right-column">
            <div className="services-image-right">
              <img src={servicesImage} alt="Our Services" />
            </div>
          </div>
        </div>

        <div className="services-bottom-text">
          <p>
            Whether you need a quick repair, a complex modification, or a custom project, Cowdog Tech is here to help. Reach out anytime for a consultation!
          </p>
        </div>
      </div>
    </div>
  );
};

export default Services;
